import { RegulatoryListData } from "@/components/business/RegulatoryContainer/Regulatory.types";
import { ProcessStatusCode } from "@/types/code.types";
import { useCreateEntryDataMutation } from "@api/createEntryData/createEntryData";
import { DRAFT_STATUS_CODE } from "@constants/draftStatusCode.constants";
import { handleRegulatoryListError } from "@utils/handleDraftError";

import RegulatoryStatus from "./components/RegulatoryStatus/RegulatoryStatus";

type Props = {
  data: RegulatoryListData;
};

const RegulatoryStatusContainer = ({ data }: Props) => {
  const { mutateAsync: createEntryData } = useCreateEntryDataMutation();

  const checkDisabledStatusButton = (status: ProcessStatusCode) => {
    if (status !== DRAFT_STATUS_CODE.aiEntryDone) return false;
    return true;
  };

  const createDAE = (id: number) => {
    createEntryData(id);
  };

  return (
    <RegulatoryStatus
      data={data}
      isDraftError={handleRegulatoryListError(data)[0]}
      draftErrorMessage={handleRegulatoryListError(data)[1]}
      createDAE={createDAE}
      disabled={checkDisabledStatusButton(data.draftArticleStatusHighest)}
    />
  );
};

export default RegulatoryStatusContainer;
